import 'bootstrap/dist/css/bootstrap.min.css';
import './components/theme/theme.css';
import {
  BrowserRouter as Router,
  Switch,
  Route
} from 'react-router-dom';
import React, { useEffect } from 'react'
import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import { IndexPage } from './page';

Bugsnag.start({
  apiKey: '8c0e3e865c88d142ab34b08d8e712bfa',
  plugins: [new BugsnagPluginReact()],
  autoTrackSessions: false,
  logger: null,
  releaseStage: process.env.REACT_APP_RELEASE_STAGE,
  enabledReleaseStages: [
    'quality_assurance',
    'user_acceptance_testing',
    'production',
  ],
});


function getParentSiteMetadata() {
  const isInIframe = window.self !== window.top;
  const meta = {
    widget: {
      href: window.location.href,
      origin: window.location.origin,
      pathname: window.location.pathname,
      search: window.location.search,
      hash: window.location.hash,
    },
    referrer: document.referrer || null,
    isInIframe,
    parent: {},
    top: {},
  };

  try {
    if (isInIframe && window.parent !== window.self) {
      meta.parent = {
        href: window.parent.location.href,
        origin: window.parent.location.origin,
        pathname: window.parent.location.pathname,
        host: window.parent.location.host,
        hostname: window.parent.location.hostname,
        protocol: window.parent.location.protocol,
      };
    }
  } catch (e) {
    meta.parent = { crossOrigin: true, message: 'Parent origin not accessible (cross-origin)' };
  }

  try {
    if (window.top !== window.self) {
      meta.top = {
        href: window.top.location.href,
        origin: window.top.location.origin,
      };
    }
  } catch (e) {
    meta.top = { crossOrigin: true, message: 'Top frame origin not accessible (cross-origin)' };
  }

  return meta;
}

const sendParentWindowError = () => {
  const metadata = getParentSiteMetadata();
  // Send information only if the widget is in an iframe
  if (metadata.isInIframe) {
    Bugsnag.addMetadata('parentSite', metadata);
    const errorMessage = metadata.top.crossOrigin || metadata.parent.crossOrigin
      ? 'Cross-origin error: ' + document.referrer
      : 'Parent window URL: ' + metadata.parent.href;
    Bugsnag.notify(new Error(errorMessage));
  }
}

function App() {
  useEffect(() => {
    sendParentWindowError();
  }, []);
  return (
    <Router>
      <Switch>
        <Route exact path='/schools/:schoolID'>
          <IndexPage />
        </Route>
        <Route exact path='/schools/:schoolID/*'>
          <IndexPage />
        </Route>
        <Route path='*'>
          <IndexPage />
        </Route>
      </Switch>
    </Router>
  );
}

export default App;
